module.exports = __webpack_public_path__ + "img/2020.e7e9f13f.png";